import React, {useState, useEffect} from 'react';
import './styles.css'
import {OutlinedInput} from "@material-ui/core";
import InputAdornment from "@material-ui/core/InputAdornment";
import SearchIcon from "@material-ui/icons/Search";
import Grid from "@material-ui/core/Grid";


/*
*  @Description : It navigates through the sent data. Searches the text entered from the keyboard in the sent keys.
*  @author  : Kerem Karadeniz
*  @Params :{data,searchKeyData}
*  @return : newData
* */


function Search(props) {
    const [value, setValue] = useState("");
    const [customClasses, setCustomClasses] = useState("");
    useEffect(() => {
        setValue("");
        if (props.customClasses && props.customClasses.length) {
            const classes = props.customClasses.join(' ');
            setCustomClasses(classes);
        }
    }, [props.data])

    function handleSearch(event) {
        let searchText = event.target.value;
        setValue(event.target.value);
        if (props.data) {
            let searchData = props.data.map(row =>
                props.searchKey.map(key =>
                    row[key] !== null && row[key].toString().toLowerCase().indexOf(searchText.toLowerCase()) !== -1))
            let newSearchData = [];
            for (let i = 0; i < searchData.length; i++) {
                if (searchData[i].indexOf(true) !== -1) {
                    newSearchData.push(props.data[i])
                }
            }

            props.setSearchData(newSearchData)
            if (searchText.length < 1) {
                props.setSearchData(props.data)
            }
        }
    }

    return (
        <div className={`searchbar-bg ${customClasses}`}>
            <Grid container spacing={props.spacing} style={{marginTop: 10}}>
                {props.label}
                <Grid item xs={props.xs} sm={props.sm} md={props.md} lg={props.lg} xl={props.xl}>
                    <OutlinedInput
                        id="outlined-adornment-amount"
                        className="searchbar-input"
                        value={value}
                        autoFocus={true}
                        onFocus={(event) => {
                            event.target.setAttribute('autocomplete', 'off');
                        }}
                        placeholder="Search..."
                        onChange={(event) => handleSearch(event)}
                        startAdornment={<InputAdornment position="start"><SearchIcon
                            className="searchbar-icon"/></InputAdornment>}

                    />
                </Grid>
                {props.children}
            </Grid>
        </div>
    )
        ;
}

export default Search;
